import Grid from '@mui/material/Grid2'
import { HeaderMenuButton } from './headerButton'
import { MenuModal } from '../menu/Modal'
import { useAuth, useHeader } from '@/hooks'
import { FC, ReactNode } from 'react'
import { styled } from '@mui/material/styles'

const PreEndIconWrapper = styled(Grid)`
  margin-right: 16px;
`

export const MenuButton: FC<{ preEndIcon?: ReactNode }> = ({ preEndIcon }) => {
  const { isAuthorized } = useAuth()
  const { isVisibleMenu, openMenu, closeMenu } = useHeader()

  return (
    <>
      {preEndIcon && <PreEndIconWrapper>{preEndIcon}</PreEndIconWrapper>}
      {isAuthorized && (
        <Grid>
          <HeaderMenuButton onClick={openMenu} />
        </Grid>
      )}
      {isAuthorized && <MenuModal isVisible={isVisibleMenu} onClose={closeMenu} />}
    </>
  )
}
